import { forwardRef } from 'react'

const Button = forwardRef(
  ({ children, variant = 'primary', size = 'md', className = '', disabled, loading, style, ...props }, ref) => {
    const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed brand-btn'
    
    const variants = {
      primary: 'text-white brand-btn-primary focus:ring-primary-500',
      secondary: 'bg-gray-200 text-gray-900 hover:bg-gray-300 focus:ring-gray-500',
      danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
      outline: 'border-2 border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-gray-500',
      ghost: 'text-gray-700 hover:bg-gray-100 focus:ring-gray-500',
    }
    
    const sizes = {
      sm: 'px-3 py-1.5 text-sm',
      md: 'px-4 py-2 text-base',
      lg: 'px-6 py-3 text-lg',
    }

    const primaryStyle =
      variant === 'primary'
        ? {
            backgroundColor: 'var(--primary-color)',
            borderColor: 'var(--primary-color)',
            borderRadius: 'var(--border-radius)',
          }
        : { borderRadius: 'var(--border-radius)' }

    const { onMouseEnter, onMouseLeave, ...rest } = props
    
    return (
      <button
        ref={ref}
        className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
        style={{ ...primaryStyle, ...style }}
        onMouseEnter={(e) => {
          if (variant === 'primary' && !disabled && !loading) {
            e.currentTarget.style.backgroundColor = 'var(--primary-600)'
          }
          onMouseEnter?.(e)
        }}
        onMouseLeave={(e) => {
          if (variant === 'primary' && !disabled && !loading) {
            e.currentTarget.style.backgroundColor = 'var(--primary-color)'
          }
          onMouseLeave?.(e)
        }}
        disabled={disabled || loading}
        {...rest}
      >
        {loading ? (
          <>
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Loading...
          </>
        ) : (
          children
        )}
      </button>
    )
  }
)

Button.displayName = 'Button'

export default Button
